module.exports = __webpack_public_path__ + "static/media/291548.185d0c33.png";